




























































import { defineComponent, computed } from '@vue/composition-api';
import { FiatAmount } from '@nimiq/vue-components';
import { useRouter, RouteName } from '@/router';
import { useStakingStore } from '@/stores/Staking';
import * as Constants from '../../lib/Constants';
import { isCurrentMonthAndStakingOngoing, getMonthLabel } from '../../lib/StakingUtils';
import { useMonthlyRewardFiatValue } from '../../composables/useMonthlyRewardFiatValue';
import ValidatorIcon from './ValidatorIcon.vue';
import Amount from '../Amount.vue';
import TextShimmer from './TextShimmer.vue';

export default defineComponent({
    name: 'StakingRewardsListItem',
    props: {
        hideIcon: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideMonth: {
            type: Boolean,
            required: false,
            default: false,
        },
        monthlyReward: {
            type: Number,
            required: true,
        },
        month: {
            type: String,
            required: true,
        },
        validatorsAddresses: {
            type: Array as () => string[],
            required: true,
        },
    },
    setup(props) {
        const router = useRouter();
        const { validators: validatorList, stakingEvents } = useStakingStore();

        const monthLabel = computed(() => getMonthLabel(props.month));
        const validators = computed(() => props.validatorsAddresses.map(
            (validator) => validatorList.value[validator] || { address: validator }),
        );

        // Check if we should show the "Ongoing" indicator
        const showOngoingIndicator = computed(() => isCurrentMonthAndStakingOngoing(props.month));

        // Calculate fiat value using month-based logic via composable
        const { fiatValue, fiatCurrency } = useMonthlyRewardFiatValue(
            computed(() => props.month),
            computed(() => props.monthlyReward),
            stakingEvents,
        );

        const openRewardsHistory = () => {
            router.push({
                name: RouteName.StakingRewards,
                params: {
                    month: props.month,
                },
            });
        };

        return {
            Constants,
            openRewardsHistory,
            monthLabel,
            validators,
            showOngoingIndicator,
            fiatValue,
            fiatCurrency,
        };
    },
    components: {
        Amount,
        FiatAmount,
        ValidatorIcon,
        TextShimmer,
    },
});
